export default {
    "aardvark": "16504922710",
    "alligator": "16508986880",
    "alpaca": "16508877991",
    "ant": "16508986891",
    "anteater": "16508986781",
    "antelope": "16508986792",
    "ape": "16504872330",
    "armadillo": "16508877067",
    "axolotl": "16505297381",
    "aye aye": "16508986870",
    "badger": "16508986771",
    "bat": "16508986892",
    "bear": "16508986782",
    "beaver": "16504682152",
    "bee": "16505676321",
    "beetle": "16508794085",
    "bird": "16508986860",
    "blackbird": "16508986871",
    "bob cat": "16508986772",
    "buffalo": "16508986893",
    "butterfly": "16508986783",
    "camel": "16508986794",
    "cardinal": "16505010371",
    "cassowary": "16508986850",
    "cat": "16508986861",
    "caterpillar": "16508986872",
    "centipede": "16508986762",
    "chameleon": "16508986773",
    "cheetah": "16508986894",
    "chickadee": "16508986784",
    "chicken": "16508986795",
    "chimpanzee": "16505676323",
    "chinchilla": "16504745602",
    "chipmunk": "16508986950",
    "cobra": "16508794087",
    "cockatoo": "16508986840",
    "cougar": "16508986862",
    "cow": "16508986873",
    "coyote": "16508986763",
    "crab": "16508986774",
    "crane": "16508986895",
    "crocodile": "16508986785",
    "crow": "16508986796",
    "deer": "16504682133",
    "dingo": "16508986951",
    "dodo": "16508986830",
    "dog": "16508986841",
    "dolphin": "16508986852",
    "donkey": "16504592264",
    "dove": "16508986863",
    "dragon": "16508986874",
    "dragonfly": "16508986764",
    "duck": "16508986885",
    "eagle": "16508986896",
    "echidna": "16508986786",
    "eel": "16508986797",
    "elephant": "16504682145",
    "elk": "16508877138",
    "emu": "16508877028",
    "falcon": "16508986940",
    "ferret": "16508986952",
    "finch": "16506441475",
    "fish": "16508986831",
    "flamingo": "16508986864",
    "fly": "16508986875",
    "fox": "16508986765",
    "frog": "16508986886",
    "gazelle": "16508986897",
    "gecko": "16508986787",
    "gerbil": "16508986798",
    "giraffe": "16504682157",
    "gnu": "16506441453",
    "goat": "16508986941",
    "goose": "16508986953",
    "gopher": "16508986832",
    "gorilla": "16508986843",
    "groundhog": "16508986854",
    "grouse": "16508986865",
    "gull": "16508986876",
    "hamster": "16508986887",
    "hawk": "16508986898",
    "hedgehog": "16504682169",
    "hen": "16505676327",
    "heron": "16505010794",
    "hippopotamus": "16508986920",
    "horse": "16508986810",
    "hummingbird": "16508986931",
    "hyena": "16508986821",
    "iguana": "16508986942",
    "insect": "16508986954",
    "jackal": "16508986833",
    "jaguar": "16508986844",
    "jellyfish": "16508986877",
    "kangaroo": "16508986899",
    "kiwi": "16504682148",
    "koala": "16505010795",
    "labradoodle": "16504592740",
    "lemming": "16504593763",
    "lemur": "16508986921",
    "leopard": "16508986811",
    "lion": "16508986932",
    "lizard": "16508986822",
    "llama": "16508986943",
    "lobster": "16508986955",
    "loon": "16508986834",
    "lynx": "16508986845",
    "magpie": "16508986856",
    "manatee": "16508986867",
    "marmot": "16508986779",
    "mink": "16505676329",
    "mole": "16505352973",
    "mongoose": "16508986801",
    "monkey": "16508986922",
    "moose": "16508986933",
    "moth": "16508986823",
    "mouse": "16508986944",
    "narwhal": "16508986956",
    "newt": "16506441479",
    "ocelot": "16508986835",
    "octopus": "16508986846",
    "opossum": "16508986857",
    "orangutan": "16504592269",
    "orca": "16508986879",
    "osprey": "16508986769",
    "ostrich": "16508986901",
    "otter": "16508986912",
    "owl": "16508986802",
    "oyster": "16508986813",
    "panda": "16508986934",
    "pangolin": "16508986824",
    "panther": "16508986836",
    "parrot": "16508986847",
    "peacock": "16508986737",
    "pelican": "16508986858",
    "penguin": "16508986869",
    "pig": "16508986902",
    "pigeon": "16508986913",
    "platypus": "16508986803",
    "pony": "16508986924",
    "porcupine": "16508986814",
    "possum": "16508986935",
    "puffin": "16508986825",
    "puma": "16508986946",
    "quail": "16508986958",
    "rabbit": "16508986837",
    "raccoon": "16508986738",
    "racoon": "16508986859",
    "rat": "16508986903",
    "raven": "16508986914",
    "ray": "16508986925",
    "rhinoceros": "16508986815",
    "roadrunner": "16508986936",
    "salamander": "16508986826",
    "salmon": "16508986947",
    "seal": "16508986959",
    "shark": "16508986838",
    "sheep": "16508986849",
    "shrimp": "16504682109",
    "skink": "16508986904",
    "skunk": "16508986915",
    "sloth": "16508986805",
    "slug": "16508986926",
    "snail": "16508986816",
    "snake": "16508986937",
    "sparrow": "16508986827",
    "spider": "16508986948",
    "squid": "16508986839",
    "squirrel": "16508986806",
    "starfish": "16508986927",
    "stork": "16508986817",
    "swallow": "16508986938",
    "swan": "16508986828",
    "tapir": "16508986949",
    "tarantula": "16508986906",
    "tiger": "16508986917",
    "tortoise": "16508986807",
    "toucan": "16508986928",
    "turkey": "16508986818",
    "turtle": "16508986939",
    "vulture": "16508986829",
    "warthog": "16508986907",
    "weasel": "16508986918",
    "whale": "16508986808",
    "wildebeest": "16508986929",
    "wolf": "16508986819",
    "wolverine": "16508986919",
    "wombat": "16508986809",
    "woodchuck": "16508986909",
    "woodpecker": "16508986790",
    "worm": "16508986890",
    "yak": "16508986791",
    "zebra": "16504682161",
}
